<script>
    import { onMount, onDestroy, tick } from "svelte";
    import MdNotifications from "svelte-icons/md/MdNotifications.svelte";
    import { fade } from "svelte/transition";
    import { visible } from "./stores";
    import { loadCss } from "../utils/styles";
    import { t } from "../i18n/I18n";

    export let modal = {};
    const {
        css = "",
        message = t("dialog.message"),
        subscribeText = t("dialog.subscribe"),
        refuseText = t("dialog.refuse"),
        icon = null
    } = modal;
    export let onSubscribe;
    export let onRefuse;

    //without init the transition doesn't work on first render
    let init = false;

    onMount(async () => {
        init = true;
        await tick();
        loadCss(atob(css));
    });
    onDestroy(() => {
        init = false;
    });
</script>

{#if init && $visible}
    <div id="ta-push-container" transition:fade>
        <div id="ta-push-dialog">
            <div class="ta-push-body">
                <div class="ta-push-body-icon">
                    <div class="ta-push-default-icon">
                        {#if icon}
                            {@html atob(icon)}
                        {:else}
                            <MdNotifications />
                        {/if}
                    </div>
                </div>
                <div class="ta-push-body-message">{atob(message)}</div>
                <div class="clearfix" />
            </div>
            <div class="ta-push-footer">
                <button
                    on:click={() => {
                        $visible = false;
                        if (typeof onRefuse === "function") {
                            onRefuse();
                        }
                    }}
                    class="ta-push-button ta-push-button-refuse">{atob(refuseText)}</button
                >
                <button
                    on:click={() => {
                        $visible = false;
                        if (typeof onSubscribe === "function") {
                            onSubscribe();
                        }
                    }}
                    class="ta-push-button ta-push-button-subscribe">{atob(subscribeText)}</button
                >
                <div class="clearfix" />
            </div>
        </div>
    </div>
{/if}

<style>
    :global(#ta-push-container) {
        font-size: 16px;
        position: fixed;
        z-index: 2258594000;
        left: 0;
        top: 0;
        right: 0;
        display: flex;
        flex-direction: row;
        justify-content: center;
        -webkit-font-smoothing: initial;
    }

    :global(#ta-push-dialog) {
        -webkit-animation-name: slideDownEnter;
        -webkit-animation-iteration-count: 1;
        -webkit-animation-timing-function: ease-out;
        -webkit-animation-duration: 0.4s;
        -webkit-animation-fill-mode: forwards;
        animation-name: slideDownEnter;
        animation-iteration-count: 1;
        animation-timing-function: ease-out;
        animation-duration: 0.4s;
        animation-fill-mode: forwards;
        display: flex;
        flex-direction: column;
        max-width: calc(500px - 1em);
        margin: 0.5em;
        box-shadow:
            0 1px 5px rgba(5, 27, 44, 0.06),
            0 2px 5px rgba(5, 27, 44, 0.16);
        background: #fff;
        padding: 1.5em;
        border-radius: 0.5em;
        font-family:
            -apple-system,
            BlinkMacSystemFont,
            Segoe UI,
            Roboto,
            Helvetica,
            Arial,
            sans-serif;
    }

    @media (max-width: 400px) {
        #ta-push-dialog {
            margin: 0;
            border-radius: 0;
        }
    }

    :global(.ta-push-body) {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        align-items: center;
        justify-content: center;
        margin-bottom: 1em;
    }

    :global(.ta-push-body-icon) {
        padding: 15px;
    }

    :global(.ta-push-default-icon) {
        width: 45px;
        height: 45px;
        color: #bdc4cb;
    }

    :global(.ta-push-body-message) {
        flex: 1;
        padding: 0 0 0 1em;
        color: #051b2c;
        font-weight: 400;
        line-height: 1.45em;
        -o-user-select: none;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
        cursor: default;
    }

    :global(.ta-push-footer) {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        justify-content: flex-end;
    }

    :global(.ta-push-button-subscribe) {
        background: var(--support-color, #f0aa07);
        color: #fff;
    }

    :global(.ta-push-button-refuse) {
        background: #ffffff;
        color: var(--support-color, #f0aa07);
    }

    :global(.ta-push-button) {
        display: -ms-flexbox;
        display: flex;
        float: right;
        font-weight: 400;
        font-size: 1em;
        padding: 0.75em 1.5em;
        margin: 0.25em;
        border: 0;
        border-radius: 0.25em;
        box-shadow: unset;
        transition: 75ms linear;
    }

    .clearfix::after {
        content: "";
        clear: both;
        display: table;
    }
</style>
